import React from 'react';
import { HiOutlineDownload } from 'react-icons/hi';

function Section4ExportReport({ visible, onExport, isExporting, disabled }) {
  if (!visible) return null;

  return (
    <section className="nlp-grouping-card">
      <h2 className="nlp-section-title">4. Export Full Sub-Group Report</h2>
      <button
        type="button"
        className="nlp-primary-btn nlp-export-btn"
        onClick={onExport}
        disabled={isExporting || disabled}
      >
        <HiOutlineDownload size={18} />
        {isExporting ? 'Preparing download…' : 'Download Hierarchical Analysis (Excel)'}
      </button>
    </section>
  );
}

export default Section4ExportReport;
